import PersistentStore from "@/api/PersistentStore";
import { MutationTree } from "vuex";
import { CENSUS_PREFERENCE_KEY, DARK_MODE_KEY } from ".";
import { DisplayTheme, NavigationState } from "./types";

export const mutations: MutationTree<NavigationState> = {
  currentId(state, id: string) {
    state.currentId = id;
  },
  darkMode(state, mode: DisplayTheme) {
    state.display.theme.mode = mode;
  },
  darkModeOs(state, darkMode: boolean) {
    const mode = darkMode ? "dark" : "light";
    // Remove previous settings - invalid
    if (
      typeof state.display.theme === "boolean" ||
      state.display.theme.mode === "unset"
    ) {
      state.display.theme = { mode: "unset", os: mode };
      PersistentStore.removeItem(DARK_MODE_KEY);
    }
    state.display.theme.os = mode;
  },
  staticTitle(state, staticTitle: boolean) {
    state.staticTitle = staticTitle;
  },
  inWrapper(state) {
    state.inWrapper = true;
  },
  setHelpStep(state, step: number) {
    state.helpStep = step;
  },
  setMobilePage(state, page: number) {
    state.mobilePage = page;
  },
  toggleLegendMobile(state) {
    state.display.showLegendMobile = !state.display.showLegendMobile;
  },
  openWindow(state, popupName) {
    if (!state.openWindows.includes(popupName)) {
      state.openWindows.push(popupName);
    }
  },
  closeWindow(state, popupName: string) {
    state.openWindows = state.openWindows.filter(w => {
      return w !== popupName;
    });
  },
  redirectTo(state, to) {
    state.redirectTo = to;
  },
  censusPreference(state, { area, pref }) {
    state.censusPreferences = PersistentStore.mergeWithExisting(
      CENSUS_PREFERENCE_KEY,
      area,
      pref,
      {}
    );
  },
  routeHistory(state, payload) {
    const { hash, fullPath, path, params, name } = payload;
    if (state.routeHistory.length >= 10) {
      state.routeHistory.shift();
    }
    state.routeHistory.push({ hash, fullPath, path, params, name });
  }
};
